var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "firm-group" },
    [
      _c(
        "b-row",
        [
          _c("csp-desktop-firm-group-basedata", {
            attrs: {
              cols: 12,
              "form-context": _vm.initialFormContexts.firmGroupBasedata,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-4" },
        [_c("csp-desktop-firm-group-firms", { attrs: { cols: 12 } })],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-4 mb-4" },
        [
          _c("csp-desktop-firm-configurable-documents", {
            attrs: {
              cols: 8,
              "context-id": _vm.firmGroupId,
              "context-type": "firmGroup",
              "form-context": _vm.initialFormContexts.firmConfigurableDocuments,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }